/**
 * Client-side logger utility.
 *
 * Provides a consistent logging interface that mirrors the server logger.
 * Faro automatically captures console output via getWebInstrumentations,
 * so we just need to call console methods - no manual Faro push needed.
 *
 * In production, info and debug logs are suppressed to reduce noise.
 * Error and warn logs are always emitted.
 */

const isProd = import.meta.env.PROD;

/**
 * Logger instance matching server interface: logger.error(msg, meta?)
 *
 * Faro's getWebInstrumentations with captureConsole:true automatically
 * intercepts console calls and sends them to Grafana.
 */
export const logger = {
  error: (msg: string, meta?: unknown) => {
    if (meta !== undefined) {
      console.error(msg, meta);
    } else {
      console.error(msg);
    }
  },
  warn: (msg: string, meta?: unknown) => {
    if (meta !== undefined) {
      console.warn(msg, meta);
    } else {
      console.warn(msg);
    }
  },
  info: (msg: string, meta?: unknown) => {
    if (isProd) return; // Suppress info logs in production
    if (meta !== undefined) {
      console.log(msg, meta);
    } else {
      console.log(msg);
    }
  },
  debug: (msg: string, meta?: unknown) => {
    if (isProd) return; // Suppress debug logs in production
    if (meta !== undefined) {
      console.debug(msg, meta);
    } else {
      console.debug(msg);
    }
  },
};
